import React, { useEffect, useState } from "react";
import analytics from "../utils/analytics";

const STORAGE_KEY = "analytics_consent";

export default function AnalyticsConsent() {
  const [consent, setConsent] = useState(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (v === "true") return true;
      if (v === "false") return false;
    } catch (e) {}
    return null; // null means not decided
  });

  useEffect(() => {
    if (consent === true) analytics.optIn();
    if (consent === false) analytics.optOut();
  }, [consent]);

  if (consent !== null) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 flex justify-center">
      <div className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 shadow rounded p-4 max-w-3xl w-full flex items-center justify-between gap-4">
        <div className="text-sm">
          We use analytics to understand usage and improve the website. No personal
          data is sent. Do you consent to anonymous analytics?
        </div>
        <div className="flex gap-2">
          <button
            className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600"
            onClick={() => {
              try {
                localStorage.setItem(STORAGE_KEY, "false");
              } catch (e) {}
              setConsent(false);
            }}
          >
            Decline
          </button>
          <button
            className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
            onClick={() => {
              try {
                localStorage.setItem(STORAGE_KEY, "true");
              } catch (e) {}
              setConsent(true);
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
